export const white = '#FFF';
export const mako = '#42454D';
export const alto = '#D8D8D8';
export const black = '#000';

const propertigrabColors = {
    white,
    mako,
    alto,
    black,
};

export default propertigrabColors;
